import {
  AmbitiousLogo,
  AutonomousLogo,
  CuriousLogo,
  ListeningLogo,
} from '../ui/common/svgs';

const softSkills = [
  {
    title: 'Autonome',
    description: 'Apprendre de nouvelles technologies est ma seconde nature.',
    logo: AutonomousLogo,
  },
  {
    title: 'Curieux',
    description: "J'aime découvrir la partie immergée de l'iceberg.",
    logo: CuriousLogo,
  },
  {
    title: 'Ambitieux',
    description: 'Mes futurs projets sont des projets réussis.',
    logo: AmbitiousLogo,
  },
  {
    title: "À l'écoute",
    description: 'Une communication efficiente avec autrui est une priorité.',
    logo: ListeningLogo,
  },
];

export default softSkills;
